import React from "react"
import types from "prop-types"

const RAW_ANSWER_DATE_MATCHER = /(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})/g

const formatDateAnswer = (rawAnswer) => (
  rawAnswer.replace(RAW_ANSWER_DATE_MATCHER, "$<month>/$<day>/$<year>")
)

const DateAnswer = ({ rawAnswer = undefined, isNewQuestion = false }) => {
  if (isNewQuestion) return null

  return (
    <div className="answer">
      {rawAnswer ? formatDateAnswer(rawAnswer) : null}
    </div>
  )
}

DateAnswer.propTypes = {
  rawAnswer: types.string,
  isNewQuestion: types.bool,
}

export default DateAnswer
